import React from "react";
import { Card, Divider, Button } from "antd";



const ReviewDetails = (props) => {
  const { quarter, reviewDate, clientName } = props;
  const ratings = [
    { criteria: "Attitude", evaluation: "Exceeds" },
    { criteria: "Communication", evaluation: "Meets" },
    { criteria: "Initiative", evaluation: "Developing" },
    { criteria: "Reliability", evaluation: "Meets" },
    { criteria: "Delivery", evaluation: "Exceeds" },
    { criteria: "Quality", evaluation: "Meets" },
    { criteria: "Adaptability", evaluation: "Developing" },
    { criteria: "Problem Solving", evaluation: "Exceeds" },
  ];
  const remarks = [
    { title: "Key Strengths", content: "Excellent technical skills, strong leadership, meets deadlines consistently" },
    { title: "Areas for Development", content: "Could improve communication with stakeholders" },
    { title: "Goals Set", content: "Lead two major projects in Q3, mentor junior developers" },
  ];
  
  return (

    <Card className=" flex flex-col gap-6 rounded-xl border-2 border-purple-200 hover:border-purple-300 transition-colors dark:border-purple-900/50 dark-mode-card">
      <div className="flex items-center gap-3 mb-2">
          <div className="rounded-md border px-2 py-0.5  bg-gradient-to-r from-emerald-600 to-purple-600 text-xs font-medium border-transparent text-white">
            {quarter}
          </div>
            <span className="text-[10px] border status-indicator completed">Completed</span>
      </div>
      <div className="flex items-center text-gray-700 text-sm dark:text-gray-200">
        Reviewed on {reviewDate}
      </div>
      <div className="flex items-center text-gray-700 text-[13px] dark:text-gray-200">
        By {clientName}
      </div>

      <Divider style={{ margin: "0.5rem 0", borderColor: "#e5e7eb" }} />

      <p className="text-[13px] font-medium mb-2 dark:text-gray-100">Performance Ratings:</p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        {ratings.map(({ criteria, evaluation }) => (
          <div key={criteria} className="flex flex-col gap-1">
            <span className="text-[11px] dark:text-white">{criteria}</span>
            <span className={`px-2 py-0.5 text-[10px] w-fit status-indicator ${evaluation.toLowerCase().replace(/\s+/g, "-")}`}>
              {evaluation}
            </span>
          </div>
        ))}
      </div>

      <Divider style={{ margin: "0.5rem 0", borderColor: "#e5e7eb" }} />
      
      <div className="space-y-3">
        {remarks.map(({ title, content }) => (
          <div key={title}>
            <p className="text-[12px] font-medium mb-1 dark:text-white">{title}:</p>
            <p className="text-[12px] dark:text-slate-100">{content}</p>
          </div>
        ))}
      </div>



      <Button
        block
        type="default"
        className="w-full mt-3 rounded-xl bg-white text-gray-800 dark-mode-card dark:text-white dark:hover:!bg-white/30"
      >
        View Full Review Details
      </Button>


    </Card>
  );
};

export default ReviewDetails;
